<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import LastmileFilter from '../../../shared/LastmileFilter.svelte';
    import MessageNotFound from '../../../shared/Messages/MessageNotFound.svelte';
    import MessageDanger from '../../../shared/Messages/MessageDanger.svelte';
    import RouteSummary from './RouteSummaryApp/RouteSummary.svelte';
    import { AssignmentApi, type EstimationRouteType } from '../AssignmentApi';
    import type { QueriesType } from '../../telematics/types';
    import SelectVehicle from '../../Vehicles/SelectVehicle.svelte';
    import IconBack from '../../../shared/Icons/IconBack.svelte';
    import ColorSymbol from '../../../shared/ColorSymbol.svelte';
    import TemplateStandard from '../../../shared/TemplateStandard.svelte';
    import TemplateInner from '../../../shared/TemplateInner.svelte';
    import {
        debug,
        deliveryList,
        disableRefreshing,
        mainMenu,
        planning,
        readonlyMode,
        scenarioManager,
    } from '../../../../stores/store';
    import { api, assignment_job_filter_config, customerSettings } from '../../../../stores/api';
    import { Umami } from '../../../utilities/Umami';
    import { runOnlyWithStartPlanning } from '../StartPlanning';
    import { Navigation } from '../../../utilities/Navigation';
    import CalcRouteButton from '../CalcRouteButton.svelte';
    import { features } from '../../../shared/Features/features';
    import Separator from '../../../shared/Separator.svelte';
    import MonitActionForDeliveryList from './MonitActionForDeliveryList.svelte';
    import IconFlashOn from '../../../shared/Icons/IconFlashOn.svelte';
    import { Const } from '../../../../stores/Const';
    import { VehiclesOnMap } from '../VehiclesOnMap/VehiclesOnMap';
    import Switch from '../../../shared/Switch.svelte';
    import PlanningDeliveryRoute from './PlanningDeliveryRoute.svelte';
    import PlanningDeliveryList from './PlanningDeliveryList.svelte';
    import RouteRealisationSummary from '../PageDeliveries2/RouteRealisationSummary.svelte';
    import type { RouteSummaryDataRouteTypeType } from './RouteSummaryApp/RouteSummaryData';
    import { vehiclesManager } from '../../Vehicles/VehiclesApp/vehiclesManager';
    import { rsa } from './RouteSummaryApp/rsa';
    import { dla } from './DeliveryListApp/dla';
    import Spinner from '../../../shared/Spinner/Spinner.svelte';
    import IconPending from '../../../shared/Icons/IconPending.svelte';
    import { switchingBetweenTabsInProgress } from './store';
    import GanttCouriers from '../../GanttCouriers/GanttCouriers.svelte';
    import {
        GanttCouriersSettings,
        GanttCouriersSettingsModeType,
    } from '../../GanttCouriers/GanttCouriersSettings';
    import { SettingsApi } from '../../Settings/SettingsApi';
    import { ScenarioApi } from '../ScenarioApi';
    import { AssignmentJob } from '../AssignmentJob';
    import type { AssignmentJobResponseType } from '../AssignmentJobApi';

    export let id: number; // assignment id
    id = parseInt(id.toString()) ?? 0;

    let queries: QueriesType = {};
    let loading: boolean = false;
    let disabled: boolean = false;
    let error: string = '';
    let totalCount: { count: number } = { count: 0 };
    let filteredCount: { count: number } = { count: 0 };
    let alreadyUsedVehicles: number[] = [];
    let showMonit: boolean = false;
    let tabRoute: boolean = false;
    let recentQueries = '{}';
    let vehiclesOnMap = new VehiclesOnMap($api);
    let filterManagerStorageKey = 'filterManager.assignments';
    let filterComponent: any;
    let getRealisationStatusTimeout: any = null;
    let vehicleName: string = '';
    let initialized: boolean = false;
    let ganttCouriersSettings: GanttCouriersSettings = new GanttCouriersSettings()
        .setSimpleView()
        .setMode(GanttCouriersSettingsModeType.CURRENT)
        .setRouteStopTimes(
            $customerSettings.each_stop_minutes,
            $customerSettings.each_delivery_minutes
        )
        .setAssignmentIds([id]);
    let toCompare: boolean = false;

    function setVisibilityOfItems(srt: RouteSummaryDataRouteTypeType, tabRoute: boolean) {
        if ($deliveryList.currentAssignment) {
            $rsa.setRowsVisibility($deliveryList.currentAssignment, tabRoute, srt);
        }
    }

    async function updateStopsQuantity(): Promise<void> {
        let routePoints = $dla.getRoutePoints();
        console.log('updateStopsQuantity, routePoints', routePoints.length);
        $rsa.setStopsQuantity(routePoints.length - 2);
        $rsa = $rsa;
    }

    async function selectVehicle(vehicleId: number | null) {
        if ($deliveryList.currentAssignment === null) {
            console.warn('selectVehicle, assignment is null');
            return;
        } else {
            let newAssId = $scenarioManager.getAssignmentIdByVehicleId(vehicleId);
            if (newAssId) {
                Navigation.navigate(`/planning/${newAssId}`);
            } else {
                let vehicles = $scenarioManager
                    .getScenarioSections()
                    .map(s => s.getVehicleId())
                    .flat();
                console.warn('selectVehicle, newAssId is null for vehicleId', vehicleId, vehicles);
            }
        }
    }

    async function getRealisationStatus() {
        if (getRealisationStatusTimeout) clearTimeout(getRealisationStatusTimeout);
        if ($deliveryList.triggerReload) {
            return;
        }
        getRealisationStatusTimeout = setTimeout(() => {
            getRealisationStatus().catch(e => {
                console.error('PageDeliveryList, getRealisationStatus, error', e);
            });
        }, Const.RELOAD_ROUTE_REALISATION_STATUS_INTERVAL_SECONDS * 1000);
        if ($disableRefreshing) {
            console.warn('PageDeliveryList, getRealisationStatus, disableRefreshing');
            return;
        }
        if (
            $deliveryList.currentAssignment &&
            ($deliveryList.currentAssignment.isLocked() ||
                $deliveryList.currentAssignment.isRouteModifiedAfterDownload())
        ) {
            AssignmentApi.getRealisationStatus(
                get(api),
                [$deliveryList.currentAssignment.getId()],
                true,
                true
            )
                .then(async response => {
                    if (!$deliveryList.currentAssignment) {
                        throw new Error('Assignment is null');
                    }
                    console.log('777getRealisationStatus, response', response[0]);
                    let routeInRealisation =
                        $deliveryList.currentAssignment.hasRouteBeenEverDownloaded() &&
                        !$deliveryList.currentAssignment.isRealised();
                    $deliveryList.currentAssignment.updateRealisationStatus(response[0]);
                    if (
                        ($deliveryList.currentAssignment.hasRouteBeenEverDownloaded() &&
                            !$deliveryList.currentAssignment.isRealised()) !== routeInRealisation
                    ) {
                        $rsa.getToConfirmRoute().isLoading = true;
                        AssignmentApi.getEstimation(
                            get(api),
                            $deliveryList.currentAssignment.getId(),
                            true,
                            $deliveryList.currentAssignment.hasRouteBeenEverDownloaded() &&
                                !$deliveryList.currentAssignment.isRealised(),
                            null //allIds
                        )
                            .then(function (estimateWithSuggestions: EstimationRouteType) {
                                if (estimateWithSuggestions && $deliveryList.currentAssignment) {
                                    $deliveryList.currentAssignment.setEstimationAlternative(
                                        estimateWithSuggestions
                                    );
                                    $rsa.importMaximumRouteFromAssignment(
                                        $deliveryList.currentAssignment
                                    );
                                    console.log(
                                        '??? updateRealisationStatus, assignment id',
                                        $rsa.getAssignmentId(),
                                        $deliveryList.currentAssignment.getId()
                                    );
                                    if (
                                        $rsa.getAssignmentId() ===
                                        $deliveryList.currentAssignment.getId()
                                    ) {
                                        $rsa.setRowsVisibility($deliveryList.currentAssignment);
                                    }
                                }
                            })
                            .finally(() => {
                                $rsa.getToConfirmRoute().isLoading = false;
                            });
                    }
                    $deliveryList = $deliveryList;
                    $dla.assignment = $deliveryList.currentAssignment;

                    $dla.setRoutePointsBySimpleData(response[0].route_points);
                    $dla.setJobServiceAttributesBySimpleData(response[0].service_attributes);

                    console.log(
                        'PageDeliveryList, 777getRealisationStatus, getApproachedItems / all',
                        $dla.getApproachedItems(),
                        $dla.getItems().length
                    );

                    $dla = $dla;
                })
                .catch(err => {
                    console.error('PageDeliveryList, getRealisationStatus, error', err);
                });
        } else {
            console.log(
                'PageDeliveryList, getRealisationStatus, no need to get realisation status'
            );
        }
    }

    async function initReloadData() {
        await $vehiclesManager.prepareData();

        setVisibilityOfItems($rsa.selectedRouteType, tabRoute);

        if (
            id > 0 &&
            ($planning.currentScenarioId === null || $deliveryList.currentAssignment === null)
        ) {
            console.debug(
                '$deliveryList.currentAssignment is null, loading assignment form $scenarioManager'
            );
            let ass = $scenarioManager.getAssignmentById(id);
            if (ass) {
                $deliveryList.currentAssignment = ass;
                $planning.currentScenarioId = ass.getScenarioId();
            }
        }

        if (
            id > 0 &&
            ($planning.currentScenarioId === null || $deliveryList.currentAssignment === null)
        ) {
            console.debug(
                '$deliveryList.currentAssignment, Scenario id is null, loading assignment form DB'
            );
            let assResponse = await AssignmentApi.getOne(get(api), id);
            $scenarioManager.updateAssignment(assResponse);
            $deliveryList.currentAssignment = $scenarioManager.getAssignmentById(id);
            $planning.currentScenarioId = assResponse.scenario_id;
            if (!$scenarioManager.getScenario() && assResponse.scenario_id) {
                let scenario = await ScenarioApi.getOne(get(api), assResponse.scenario_id);
                if (scenario) {
                    $scenarioManager.setScenario(scenario);
                }
            }
        }

        // vehicleName = $deliveryList.currentAssignment?.getName() ?? '(brak nazwy)'; // TODO: get name from assignment when ready
        if ($deliveryList.currentAssignment) {
            vehicleName =
                $vehiclesManager
                    .getItems()
                    .find(v => v.getId() === $deliveryList.currentAssignment?.getVehicleId())
                    ?.getName() ?? '(brak nazwy)';
        }

        if ($deliveryList.currentAssignment?.isRouteInCalculation() || $deliveryList.currentAssignment?.isBeingProcessed()) {
            setTimeout(refreshAssignment, 1000 + Math.random() * 500);
        }

        reloadRsa();
    }

    function reloadRsa() {
        if ($deliveryList.currentAssignment && id > 0) {
            console.log('DeliveryList, reloadData, reload $rsa data');
            $rsa = $rsa.startLoading();
            $rsa.reload($deliveryList.currentAssignment, $planning.selectedDay)
                .then(ass => {
                    // assignment = ass;
                    $dla.setAssignment(ass);
                    $deliveryList.currentAssignment = ass;
                    $deliveryList = $deliveryList;
                    setVisibilityOfItems($rsa.selectedRouteType, tabRoute);
                })
                .catch(err =>
                    console.error('DeliveryList, Cannot load estimate for some route', err)
                )
                .finally(() => {
                    $rsa = $rsa.stopLoading();
                });
        } else {
            console.warn('DeliveryList, Assignment is null, so cannot load $rsa data');
        }
    }

    async function reloadData(afterInit: boolean = false) {
        if (loading) {
            console.warn('DeliveryList, reloadData, loading?', loading, 'skipping reload');
            return false;
        }

        if (id > 0 && $deliveryList.currentAssignment === null) {
            console.warn(
                'DeliveryList, $deliveryList.currentAssignment is null, ' +
                    $scenarioManager.getScenarioSections().length
            );
            return false;
        }

        if (id > 0 && $planning.currentScenarioId === null) {
            console.warn('DeliveryList, $planning.currentScenarioId is null');
            return false;
        }

        loading = true;

        $dla.setAssignmentId(id);

        if (
            $deliveryList.currentAssignment &&
            ($deliveryList.currentAssignment.isRealised() ||
                $deliveryList.currentAssignment.isLocked())
        ) {
            ganttCouriersSettings.setMode(GanttCouriersSettingsModeType.APPROACHED);
        } else {
            ganttCouriersSettings.setMode(GanttCouriersSettingsModeType.CURRENT);
        }
        ganttCouriersSettings.tickCounter(true);
        ganttCouriersSettings = ganttCouriersSettings;

        if (id > 0) {
            $dla.setAssignment($deliveryList.currentAssignment);
            $dla.setScenarioId($planning.currentScenarioId);
        } else {
            $dla.setAssignment(null);
            $dla.setScenarioId(null);
        }

        setVisibilityOfItems($rsa.selectedRouteType, tabRoute);

        Promise.all([
            // id == Const.ASSIGNMENT_UNSET
            //     ? ScenarioApi.getOneForDay(get(api), $planning.selectedDay)
            //     : Promise.resolve(null),
            !afterInit ? $vehiclesManager.prepareData() : null,
            $dla.setQuery({ ...queries }).prepareData($planning.selectedDay, !afterInit),
            !afterInit ? $dla.populateAssignment() : null,
        ])
            .then(response => {
                console.log('onChangeRow reloadData');
                initialized = true;

                $deliveryList.triggerReload = false;
                $vehiclesManager = $vehiclesManager;
                // if (id === Const.ASSIGNMENT_UNSET && response[0]) {
                //     if ($planning.currentScenarioId !== response[0].id) {
                //         throw new Error('Scenario id is not equal');
                //     }
                //     $deliveryListManager.setScenarioId(response[0].id);
                // }

                if ($dla.assignment === null) {
                    throw new Error('Assignment is null, $deliveryListManager.assignment');
                }
                /*if ($dla.assignment && $dla.day) {
                    console.log(
                        'DeliveryList, queries',
                        $dla.getShowSuggestedDeliveries(),
                        $dla.getShowUnassignedDeliveries()
                    );
                    $dla.setQuery({
                        ...queries,
                    })
                        .load()
                        .then(() => {
                            $dla = $dla;
                        });
                } else {
                    console.warn(
                        'PageDeliveryList, queries, ',
                        $dla.assignment,
                        $dla.assignment.getId() === id,
                        $dla.day
                    );
                }*/

                $dla = $dla;

                $deliveryList.currentAssignment = $dla.assignment;
                toCompare = $dla.assignment?.isComparative() && $scenarioManager.getScenario().to_compare_only || $scenarioManager.getAllScenariosToCompare().filter((s) => s.id == $dla.assignment?.getScenarioId()).length > 0;
                if (toCompare) {
                    $dla.assignment?.setComparative(true);
                    $deliveryList.currentAssignment?.setComparative(true);
                    let scenarioId = $scenarioManager.getScenario().to_compare_only ? $scenarioManager.getScenario().id : $dla.assignment?.getScenarioId();
                    if (scenarioId) {
                        ScenarioApi.getAssignmentJobsToCompare($api, scenarioId, {assignment_id: $dla.assignment?.getId()}).then((response: any[]) => {
                            $dla.setItems(response.map(aj => { return new AssignmentJob(aj); }));
                            $dla = $dla;
                        });
                    }
                }

                $deliveryList.currentAssignment.setVehicleFromAll2($vehiclesManager.getItems());

                $planning.currentScenarioId = $deliveryList.currentAssignment.getScenarioId(); // when page is loaded directly from url we need to load scenario id from assignment

                if (
                    $deliveryList.currentAssignment &&
                    $deliveryList.currentAssignment.getVehicle()
                ) {
                    $scenarioManager.updateAssignment($deliveryList.currentAssignment.get());
                    if (typeof $deliveryList.currentAssignment.getVehicle()?.id === 'number') {
                        vehiclesOnMap.setPointsToTrack(
                            $scenarioManager.getVehiclesWithColors([
                                $deliveryList.currentAssignment.getVehicle()?.id as number,
                            ]),
                            $scenarioManager.getScenarioSections(false)
                        );
                    } else {
                        console.warn('PageDeliveryList, reloadData, vehicle is not set (id)');
                    }
                } else {
                    console.warn(
                        'PageDeliveryList, reloadData, vehicle is not set (vehicle) or assignment is null'
                    );
                }

                if (!afterInit) {
                    reloadRsa();
                }


                (async () => {
                    await $dla.loadExtendedRoutePoints().catch(e => {
                        console.error('PageDeliveryList, loadExtendedRoutePoints, error', e);
                    });
                    await updateStopsQuantity();
                    $dla = $dla;
                    await getRealisationStatus().catch(e => {
                        console.error('PageDeliveryList, getRealisationStatus, error', e);
                    });
                })();
            })
            .catch(err => {
                console.error('PageDeliveryList, reloadData, error', err);
                error = err;
            })
            .finally(() => {
                loading = false;
            });
    }

    function refreshAssignment() {
        if ($deliveryList.currentAssignment?.isDefault()) {
            AssignmentApi.getOne(
                get(api),
                $deliveryList.currentAssignment.getId()
            ).then(response => {
                if ($deliveryList.currentAssignment) {
                    $deliveryList.currentAssignment.set(response);
                    if ($deliveryList.currentAssignment.isRouteInCalculation() || $deliveryList.currentAssignment.isBeingProcessed()) {
                        setTimeout(refreshAssignment, 1000 + Math.random() * 500);
                    } else {
                        $deliveryList.currentAssignment.setBusy(false);
                    }
                    $deliveryList.currentAssignment = $deliveryList.currentAssignment;
                }
            });
        }
    }

    onMount(() => {
        $mainMenu.currentPage = 'PagePlanning';
        $deliveryList.selectedOrUnselected = [];
        $deliveryList.selectMode = 'selected';

        $dla.resetStatus(true);
        $rsa.reset();
        $rsa.setRowsVisibilityCallback(async srt => {
            if (srt === 'to_confirm') {
                $dla.setShowSuggestedDeliveries(true);
                $dla.setShowUnassignedDeliveries(false);
            } else if (srt === 'to_assign') {
                $dla.setShowSuggestedDeliveries(true);
                $dla.setShowUnassignedDeliveries(true);
            } else {
                $dla.setShowSuggestedDeliveries(false);
                $dla.setShowUnassignedDeliveries(false);
            }
            $dla.setShowOnlyInRealisation(srt === 'current_in_realisation');
            if (initialized) {
                await $dla.load().then(()=>{
                }).catch(e => {
                    console.error('PageDeliveryList, reloadData, error', e);
                });
            }
            $dla = $dla;
        });

        $rsa.setListener('confirmAllToConfirm', async () => {
            console.log('Confirming all');
            Umami.event('jobs_auto_confirm', { assignment_id: $deliveryList.currentAssignment.getId() });
            await AssignmentApi.confirmAllJobs(
                $api,
                $deliveryList.currentAssignment.getId(),
                $planning.selectedDay
            ).catch(err => {
                Umami.error('jobs_auto_confirm', err, { assignment_id: $deliveryList.currentAssignment.getId() });
                console.error(err);
            });
            await $dla.triggerReload().catch(err => {
                console.error(err);
            });
            $deliveryList.triggerReload = true;
        });

        (async () => {
            $assignment_job_filter_config = await SettingsApi.getFilterConfig($api, 'assignment_job').catch(err => {;
                console.error('PageDeliveryList, getFilterConfig, error', err);
                return null;
            });
            await initReloadData().catch(err => {
                console.error('PageDeliveryList, initReloadData, error', err);
            });
            await reloadData(true).catch(err => {
                console.error('PageDeliveryList, reloadData, error', err);
            });
        })();

        return () => {
            if (vehiclesOnMap) vehiclesOnMap.destroy();
            if (getRealisationStatusTimeout) {
                clearTimeout(getRealisationStatusTimeout);
            }
            $deliveryList.currentAssignment = null;
            $dla.resetStatus();
            $deliveryList.isRouteVariantVisible = false; // reset these settings when page is closed
        };
    });

    $: alreadyUsedVehicles = $scenarioManager.getAlreadyUsedVehiclesIds();

    $: showMonit =
        $deliveryList.selectMode === 'filtered' || $deliveryList.selectedOrUnselected.length > 0;

    // $: vehiclesOnMap.setRandomMode($features.feature_1360_track_vehicles_random);
    // disabled due to set jobs as completed
    $: vehiclesOnMap.setRandomMode(false); // $features.feature_1360_track_vehicles_random

    $: {
        if ($deliveryList.triggerReload) {
            if (getRealisationStatusTimeout) {
                clearTimeout(getRealisationStatusTimeout);
            }
            console.log('PageDeliveryList, triggerReload', $deliveryList.currentAssignment);
            reloadData();
        }
    }
    $: {
        console.log(
            'PlanningDeliveryList, queries',
            queries,
            recentQueries,
            JSON.stringify(queries) !== recentQueries
        );
        // queries = queries;
        if (JSON.stringify(queries) !== recentQueries) {
            recentQueries = JSON.stringify(queries);
            // filterChanged = true;
            loading = false;
            reloadData();
        }
    }

    $: {
        if ($deliveryList.currentAssignment?.isRouteCalculated()) {
            console.log(
                'PageDeliveryList, currentAssignment.isRouteCalculated',
                $deliveryList.currentAssignment?.isRouteCalculated()
            );
            $rsa.importBaseRouteFromAssignment($deliveryList.currentAssignment, $dla.getItems());
            $rsa = $rsa;
        } else if (tabRoute && !$deliveryList.currentAssignment?.isRouteInCalculation()) {
            tabRoute = false;
        }
    }

    $: {
        if (
            $deliveryList.currentAssignment !== null &&
            id !== $deliveryList.currentAssignment.getId()
        ) {
            $deliveryList.currentAssignment = null;
            (async () => {
                console.log(
                    'PageDeliveryList2 - reload due to invalid loaded data - proper id: ' + id
                );
                await initReloadData().catch(err => {
                    console.error('PageDeliveryList, initReloadData, error', err);
                });
                await reloadData(true).catch(err => {
                    console.error('PageDeliveryList, reloadData, error', err);
                });
            })();
        }
    }

    $: {
        disabled = disabled;
        console.log('PageDeliveryList2, loading, disabled', disabled);
    }
</script>

{#if $deliveryList.currentAssignment === null || id !== $deliveryList.currentAssignment.getId()}
    <div
        style="display: flex; flex-direction: row; align-items: center; column-gap: 6px; justify-content: center; height: 160px;"
    >
        <IconPending spin={true} scale={1} />
    </div>
    {#if $debug}
        <div>
            <div>
                $deliveryList.currentAssignment.getId() = {$deliveryList.currentAssignment?.getId()}
            </div>
            <div>id = {id}</div>
        </div>
    {/if}
{:else}
    <TemplateStandard>
        <div slot="submenu">
            <div
                class="header"
                style="margin: 0; padding: 20px 20px 10px 20px; display:flex; justify-content: space-between; flex-wrap: wrap; row-gap: 10px;"
            >
                <div style="display: flex; align-items: flex-start; flex: 0 1 auto;">
                    <div
                        style="display: flex; flex-direction: row; align-items: center; column-gap: 0;"
                    >
                        <IconBack
                            on:click={() => {
                                Navigation.navigate('/planning');
                            }}
                        />
                        {#if $deliveryList.currentAssignment !== null && !$deliveryList.currentAssignment.isDefault()}
                            {#if $deliveryList.currentAssignment.isAdHoc()}
                                <IconFlashOn scale={1} />
                                <div style="font-size: 18px; line-height: 18px; opacity: 0.6">
                                    {$_('jobs_ad_hoc')}
                                </div>
                            {:else}
                                <ColorSymbol
                                    color={$deliveryList.currentAssignment.getColor()}
                                    opts={$deliveryList.currentAssignment.getPinOpts()}
                                    scale={1}
                                />
                                <div style="font-size: 20px; line-height: 20px; font-weight: 500">
                                    ({$_('unassigned_jobs')})
                                </div>
                            {/if}
                        {:else if id === 0}
                            <!--                        https://er.automapa.pl/issues/41798-->
                            <ColorSymbol color={'#f9e196'} opts={{}} scale={1} />
                            <div style="font-size: 20px; line-height: 20px; font-weight: 500">
                                ({$_('unassigned_jobs')})
                            </div>
                        {/if}
                        {#if $deliveryList.currentAssignment !== null && $deliveryList.currentAssignment.isDefault()}
                            <div>
                                <div
                                    style="display: flex; flex-direction: row; padding-bottom: 5px; align-items: center; column-gap: 5px;"
                                >
                                    {#if $debug}
                                        ass: {$deliveryList?.currentAssignment?.getId()}
                                    {/if}
                                    <div
                                        style="font-size: 22px; line-height: 22px; font-weight: 500"
                                    >
                                        {vehicleName}
                                    </div>
                                    <div style="margin-left: 6px; color:#000;">
                                        <RouteRealisationSummary
                                            assignment={$deliveryList.currentAssignment}
                                            showProgress={false}
                                            extended={true}
                                        />
                                    </div>
                                </div>
                                <div class="zone" style="margin-left: 0;">
                                    <span class="lite">{$_('Zone')}:</span><span
                                        class="bold"
                                        style="margin-left: 5px; font-size: var(--font-size-tactical-plan)"
                                    >
                                        {$deliveryList.currentAssignment.getZoneName() ||
                                            '<' + $_('brak') + '>'}</span
                                    >
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
                <div
                    class="route-summary-placeholder"
                    class:feature_filter_column={$features.feature_filter_column}
                >
                    {#if $deliveryList.currentAssignment && $deliveryList.currentAssignment.isDefault()}
                        <RouteSummary
                            switchableRoutes={!toCompare}
                            disabled={disabled || $readonlyMode || toCompare}
                            bind:assignment={$deliveryList.currentAssignment}
                            bind:loading={disabled}
                            selectedRouteType={$rsa.selectedRouteType}
                            {tabRoute}
                            onChange={srt => {
                                $rsa.selectedRouteType = srt;
                                //setVisibilityOfItems(srt);
                                reloadData();
                                return true;
                            }}
                        />
                    {:else}
                        <div style="height: 40px"></div>
                    {/if}
                </div>
                {#if !toCompare}
                    <div
                        class="lastmile-filter-placeholder"
                        class:feature_filter_column={$features.feature_filter_column}
                    >
                        <LastmileFilter
                            collectionName="assignment"
                            onChange={(q, andOrSelection, allQueries, changed) => {
                                console.log('LastmileFilter', q, andOrSelection, allQueries, changed);
                                queries = q;
                                $deliveryList.query = q;
                            }}
                            filterConfig={$assignment_job_filter_config}
                            enableInactiveQueries={true}
                            {filterManagerStorageKey}
                            andOrSelectionEnabled={false}
                            bind:this={filterComponent}
                            totalCount={totalCount.count}
                            filteredCount={filteredCount.count}
                            showButtonRestoreFilter={false}
                        />
                    </div>
                {/if}
            </div>

            <div class="header"></div>
        </div>
        <div slot="monit">
            {#if showMonit}
                <div style="position: relative; z-index: 200;">
                    <MonitActionForDeliveryList disabled={$readonlyMode || toCompare} />
                </div>
            {/if}
        </div>
        <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
            {#if error}
                <MessageDanger {error} />
            {/if}
            {#if $debug}
                assignment.isRouteCalculated(): {$deliveryList?.currentAssignment?.isRouteCalculated()}
            {/if}
            {#if $deliveryList.currentAssignment && $deliveryList.currentAssignment?.isDefault()}
                <div
                    style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; flex-wrap: wrap; row-gap: 10px; column-gap: 20px; margin-bottom: 8px; min-height:24px;"
                    class:blur={showMonit}
                >
                    <CalcRouteButton
                        disabled={disabled || $readonlyMode || toCompare}
                        extendedVersion={true}
                        showButtonCalc={true}
                        showButtonOptimize={$deliveryList.currentAssignment?.isRouteManuallyModified() &&
                            !$deliveryList.currentAssignment?.isDownloaded() &&
                            !$deliveryList.isRouteVariantVisible}
                        showButtonReverse={tabRoute &&
                            $features.feature_reverse_route &&
                            !$deliveryList.currentAssignment.isLocked() &&
                            !$deliveryList.currentAssignment?.isDownloaded() &&
                            !$deliveryList.isRouteVariantVisible}
                        showButtonSend={false}
                        bind:assignment={$deliveryList.currentAssignment}
                        onStartCalc={() => {
                            console.log('onStartCalc');
                            if (true) {
                                // feature_switch_to_route_view_while_manual_calc_route
                                if (!tabRoute) tabRoute = true;
                            }
                        }}
                        onFinishCalc={() => {
                            console.log('onFinishCalc');
                            if (true) {
                                // feature_switch_to_route_view_while_manual_calc_route
                                $deliveryList.triggerReload = true;
                            }
                        }}
                        onChangeStartTime={selectedHour => {
                            ganttCouriersSettings.tickCounter(true);
                            ganttCouriersSettings = ganttCouriersSettings;
                            return true;
                        }}
                    />
                    <div
                        style="font-weight: 600; font-size: var(--font-size-tactical-plan); display: flex; justify-content: flex-end; flex: 1 1 auto;"
                    >
                        <Switch
                            label={$_('Show as route')}
                            bind:checked={tabRoute}
                            disabled={!$deliveryList.currentAssignment.isRouteCalculated() ||
                                ($deliveryList.isRouteVariantVisible && tabRoute) ||
                                disabled ||
                                $switchingBetweenTabsInProgress}
                            on:change={e => {
                                if ($deliveryList.currentAssignment === null) {
                                    console.warn('Switch, assignment is null');
                                    return;
                                }
                                $switchingBetweenTabsInProgress = true;
                                $rsa.setRowsVisibility(
                                    $deliveryList.currentAssignment,
                                    e.detail.checked,
                                    $rsa.selectedRouteType
                                );
                            }}
                        />
                    </div>
                </div>
            {/if}
            {#if loading}
                <div style="min-height: 100px;">
                    <Spinner />
                </div>
            {:else if initialized}
                {#if tabRoute}
                    {#if $deliveryList.currentAssignment && $deliveryList.currentAssignment.isDefault()}
                        {#if $deliveryList.currentAssignment.hasVehicleAssigned()}
                            <PlanningDeliveryRoute
                                bind:assignment={$deliveryList.currentAssignment}
                                disabled={disabled || $readonlyMode || toCompare}
                                bind:ganttCouriersSettings
                            />
                        {:else}
                            <TemplateInner>
                                <MessageNotFound
                                    text={$_('Vehicle must be assigned before create route')}
                                />
                                <SelectVehicle
                                    selected={null}
                                    vehicleColor={$deliveryList.currentAssignment.getColor()}
                                    allowToRemoveAssignment={false}
                                    bind:alreadyUsedVehicles
                                    onChange={v => {
                                        if (v) {
                                            runOnlyWithStartPlanning(() => {
                                                selectVehicle(v);
                                                return true;
                                            });
                                        }
                                        return false;
                                    }}
                                />
                            </TemplateInner>
                        {/if}
                    {:else}
                        <TemplateInner>
                            <MessageNotFound
                                text={$_('Route is not available for unassigned deliveries')}
                            />
                        </TemplateInner>
                    {/if}
                {:else if $deliveryList.currentAssignment}
                    {#if $debug}
                        <div>loading: {loading}</div>
                        <div>disabled: {disabled}</div>
                    {/if}
                    <PlanningDeliveryList
                        makeBlured={showMonit}
                        disabled={disabled || $readonlyMode || toCompare}
                        {queries}
                        bind:assignment={$deliveryList.currentAssignment}
                        bind:totalCount
                        bind:filteredCount
                        onPolygonDraw={geom => {
                            queries.geom = geom;
                            filterComponent.updateFilters(queries);
                        }}
                    />
                {/if}
            {/if}
        </div>
        <div slot="footer">
            {#if tabRoute && $features?.feature_enable_gantt_in_delivery_list}
                <div style="border-top: 4px solid #eee; padding: 0 30px 10px 20px;">
                    <GanttCouriers {ganttCouriersSettings} />
                </div>
            {/if}
        </div>
    </TemplateStandard>
{/if}

<style>
    .header {
        background-color: #fafafa;
        padding-bottom: 4px !important;
    }
    .lastmile-filter-placeholder {
        width: 100%;
    }
    .lastmile-filter-placeholder.feature_filter_column {
        /*position: relative !important;*/
        /*top: -49px !important;*/
        /*position: absolute;*/
        /*transform: translateY(-44px);*/
    }
    .route-summary-placeholder {
        flex: 0 1 auto;
        margin-left: auto;
        width: 580px;
    }
    .route-summary-placeholder.feature_filter_column {
        /*position: absolute;*/
    }
</style>
